import type { Accept } from 'react-dropzone'

/**
 * A list of MIME types as react-dropzone's `accept` map.
 *
 * The extension lists stay empty: `acceptPropAsAcceptAttr` flattens keys and extensions into one
 * comma-separated `accept` attribute, so the file picker and drag-drop both match on MIME type
 * alone. Extensions would only matter under `useFsAccessApi`, which defaults to false.
 */
export const acceptMimeTypes = (mimeTypes: string[]): Accept =>
  Object.fromEntries(mimeTypes.map(mimeType => [mimeType, []]))
